import { render, staticRenderFns } from "./DelvieryTable.vue?vue&type=template&id=22ab205b&scoped=true&"
import script from "./DelvieryTable.vue?vue&type=script&lang=js&"
export * from "./DelvieryTable.vue?vue&type=script&lang=js&"
import style0 from "./DelvieryTable.vue?vue&type=style&index=0&id=22ab205b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab205b",
  null
  
)

export default component.exports